(function () {
  if (window.__quantityPresetInit) return;
  window.__quantityPresetInit = true;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function setDisplayedPrice(cents) {
    const priceEl = document.querySelector('.product-info__block-item sale-price');
    if (!priceEl) return;
    const formatted = formatMoney(cents);
    const textNode = Array.from(priceEl.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '');
    if (textNode) {
      textNode.textContent = formatted;
    } else {
      priceEl.appendChild(document.createTextNode(formatted));
    }
  }

  function setDiscountInfo(discountPct, realPriceCents) {
    const discountInfo = document.querySelector('[data-quantity-discount-info]');
    if (!discountInfo) return;

    if (discountPct > 0) {
      const compareEl = discountInfo.querySelector('compare-at-price');
      const badgeEl = discountInfo.querySelector('[data-quantity-discount-badge]');
      if (compareEl) compareEl.textContent = formatMoney(realPriceCents);
      if (badgeEl) badgeEl.textContent = `-${discountPct}%`;
      discountInfo.classList.remove('hidden');
    } else {
      discountInfo.classList.add('hidden');
    }
  }

  function getActiveQuantityButton() {
    return Array.from(document.querySelectorAll('.quantity-preset.is-active'))
      .find(btn => btn.dataset.quantity && !btn.closest('[data-subscription-selector]'));
  }

  function getSelectedQuantity() {
    const activeBtn = getActiveQuantityButton();
    return activeBtn ? parseInt(activeBtn.dataset.quantity) : 1;
  }

  // Single source of truth for the price shown near the add-to-cart button. Three independent controls can each
  // change what should be displayed — the quantity presets, the subscription toggle/frequency, and a variant change —
  // so instead of each of them pushing its own price directly, they all call this afterwards, and it composes the
  // *current* combined state (quantity x either the one-time or the subscription unit price) itself.
  function recomputeDisplayedPrice() {
    const quantity = getSelectedQuantity();
    const subscriptionRoot = document.querySelector('[data-subscription-selector]');
    const radio = subscriptionRoot ? subscriptionRoot.querySelector('input[type="radio"]') : null;

    if (radio && radio.checked) {
      const frequencySelect = subscriptionRoot.querySelector('[data-subscription-frequency-select]');
      const option = frequencySelect ? frequencySelect.selectedOptions[0] : null;
      if (!option) return;

      const unitPrice = parseInt(option.dataset.price);
      const discountPct = parseInt(option.dataset.discountPct || '0');
      const basePrice = parseInt(subscriptionRoot.dataset.basePrice || '0');

      setDisplayedPrice(unitPrice * quantity);
      setDiscountInfo(discountPct, basePrice * quantity);
      return;
    }

    // One-time purchase: the active quantity-preset button already carries its own (bulk-discounted) total.
    const activeBtn = getActiveQuantityButton();
    if (activeBtn) {
      setDisplayedPrice(parseInt(activeBtn.dataset.price));
      setDiscountInfo(parseInt(activeBtn.dataset.discountPct || '0'), parseInt(activeBtn.dataset.realPrice || activeBtn.dataset.price));
    }
  }

  function syncQuantity(quantity, vstack) {
    const themeQtySelector = vstack.querySelector('.quantity-selector');
    if (themeQtySelector && themeQtySelector.quantity !== undefined) {
      themeQtySelector.quantity = quantity;
    } else {
      const input = vstack.querySelector('.quantity-selector .quantity-selector__input');
      if (input) {
        input.value = quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  // Single delegated listener on document — survives all re-renders
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity-preset');
    if (!btn) return;
    if (btn.closest('[data-subscription-selector]')) return;
    if (!btn.dataset.price || parseInt(btn.dataset.price) === 0) return;

    const quantity = parseInt(btn.dataset.quantity);

    // Active state (scoped to quantity-preset buttons only — the subscription card also uses the ".quantity-preset"
    // class for shared styling, but its own active/checked state must not be touched here)
    document.querySelectorAll('.quantity-preset').forEach(b => {
      if (!b.closest('[data-subscription-selector]')) b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    // Sync quantity inputs
    const vstack = btn.closest('.v-stack');
    if (vstack) syncQuantity(quantity, vstack);

    // Update price (composed with whatever the subscription toggle currently says)
    recomputeDisplayedPrice();
  });

  // Subscription selector: a single radio activates the subscription (there is no separate "one-time" control —
  // one-time is simply the default, unchecked state).
  function updateSubscriptionSelection(root) {
    const radio = root.querySelector('input[type="radio"]');
    const card = root.querySelector('[data-subscription-card]');
    const frequencyWrapper = root.querySelector('[data-subscription-frequency-wrapper]');
    const frequencySelect = root.querySelector('[data-subscription-frequency-select]');
    const advantagesList = root.querySelector('[data-subscription-advantages]');
    const input = root.querySelector('[data-subscription-input]');
    if (!radio || !input) return;

    const isSubscription = radio.checked;

    if (card) card.classList.toggle('is-active', isSubscription);
    if (frequencyWrapper) frequencyWrapper.hidden = !isSubscription;
    if (advantagesList) advantagesList.hidden = !isSubscription;
    input.disabled = !isSubscription;

    if (isSubscription) {
      const option = frequencySelect ? frequencySelect.selectedOptions[0] : null;
      if (option) input.value = option.value;
    }

    // Price is composed with whatever quantity is currently selected, not just this control's own state
    recomputeDisplayedPrice();
  }

  // Track each radio's checked state so a click can detect "it was already checked" and toggle it back off — plain
  // radios can't be unchecked by clicking them again, but this one has no sibling in its "name" group, so it should
  // behave as an on/off toggle rather than a real (permanent, one-way) radio choice.
  document.querySelectorAll('[data-subscription-selector] input[type="radio"]').forEach(radio => {
    radio.dataset.wasActive = radio.checked ? 'true' : 'false';
  });

  document.addEventListener('click', function (e) {
    const radio = e.target.closest('[data-subscription-selector] input[type="radio"]');
    if (!radio) return;

    if (radio.checked && radio.dataset.wasActive === 'true') {
      radio.checked = false;
    }
    radio.dataset.wasActive = radio.checked ? 'true' : 'false';

    const root = radio.closest('[data-subscription-selector]');
    if (root) updateSubscriptionSelection(root);
  });

  // Make the whole card clickable, not just the radio/label. Clicks that land directly on the radio or its label
  // are already handled above (native activation + our toggle-off logic) — this only handles clicks elsewhere in
  // the card (e.g. on the discount badge or empty space) by toggling the radio ourselves.
  document.addEventListener('click', function (e) {
    const card = e.target.closest('[data-subscription-card]');
    if (!card) return;
    if (e.target.closest('input[type="radio"], label[for]')) return;

    const radio = card.querySelector('input[type="radio"]');
    if (!radio) return;

    radio.checked = !radio.checked;
    radio.dataset.wasActive = radio.checked ? 'true' : 'false';

    const root = card.closest('[data-subscription-selector]');
    if (root) updateSubscriptionSelection(root);
  });

  document.addEventListener('change', function (e) {
    const select = e.target.closest('[data-subscription-frequency-select]');
    if (!select) return;

    const root = select.closest('[data-subscription-selector]');
    if (!root) return;

    updateSubscriptionSelection(root);
  });

  // Same discount rule as snippets/quantity-preset.liquid ("i == 2" -> 5%, "i == 3" -> 10%). Duplicated here because,
  // unlike price/inventory/buy-buttons, the "quantity-preset" block isn't part of <product-rerender>'s native
  // block-type refresh list (that list lives in the compiled theme.js, which we don't edit), so on variant change we
  // can't rely on a fresh server-rendered copy of this block — its prices must be recomputed client-side instead.
  function computePresetPrice(basePrice, quantity) {
    let discountPct = 0;
    if (quantity === 2) discountPct = 5;
    else if (quantity === 3) discountPct = 10;

    let price = basePrice * quantity;
    if (discountPct > 0) {
      price = Math.round(price * (100 - discountPct) / 100);
    }
    return { price, discountPct };
  }

  // On variant change, the native <product-rerender> mechanism already refreshes the price block with the new
  // variant's price. We must recompute (not just re-read stale DOM) the quantity-preset buttons from the new variant
  // price carried by the event, then reset the selection to qty=1 so the displayed price matches the new variant.
  document.querySelectorAll('form[id^="product-form-"]').forEach(form => {
    form.addEventListener('variant:change', (e) => {
      const newVariant = e.detail && e.detail.variant;
      if (!newVariant) return;

      document.querySelectorAll('.quantity-preset').forEach(btn => {
        if (btn.closest('[data-subscription-selector]')) return;

        const quantity = parseInt(btn.dataset.quantity);
        if (!quantity) return;

        const { price, discountPct } = computePresetPrice(newVariant.price, quantity);
        btn.dataset.price = price;
        btn.dataset.basePrice = newVariant.price;
        btn.dataset.realPrice = newVariant.price * quantity;
        btn.dataset.discountPct = discountPct;

        const priceEl = btn.querySelector('.quantity-preset__price');
        if (priceEl) priceEl.textContent = formatMoney(price);

        const compareEl = btn.querySelector('.opacity-50.line-through');
        if (compareEl) compareEl.textContent = formatMoney(newVariant.price * quantity);

        const badgeEl = btn.querySelector('.quantity-preset__badge:not([data-free-shipping-tag])');
        if (badgeEl) badgeEl.textContent = `-${discountPct}%`;

        const shippingTag = btn.querySelector('[data-free-shipping-tag]');
        const threshold = parseInt(btn.closest('.quantity-presets')?.dataset.freeShippingThreshold || '0');
        if (shippingTag) shippingTag.hidden = !(threshold > 0 && price >= threshold);
      });

      const firstBtn = Array.from(document.querySelectorAll('.quantity-preset[data-quantity="1"]'))
        .find(btn => !btn.closest('[data-subscription-selector]'));

      if (firstBtn) {
        document.querySelectorAll('.quantity-preset').forEach(b => {
          if (!b.closest('[data-subscription-selector]')) b.classList.remove('is-active');
        });
        firstBtn.classList.add('is-active');

        const vstack = firstBtn.closest('.v-stack');
        if (vstack) syncQuantity(1, vstack);
      }

      // Subscription selector: refresh the base price used for the "one-time" reference point. Per-frequency
      // subscription pricing depends on server-side selling plan allocations for this variant, which aren't
      // available client-side, so the frequency dropdown keeps its previous amounts until the page reloads.
      document.querySelectorAll('[data-subscription-selector]').forEach(root => {
        root.dataset.basePrice = newVariant.price;
      });

      // Recompute last: composes quantity x (subscription or one-time) using the data we just refreshed above
      recomputeDisplayedPrice();
    });
  });

  // Newsletter popup: clicking the dark overlay closes the popup, same as the close button. The overlay is a
  // sibling of <newsletter-popup> (not a descendant), so we call the element's public hide() method directly
  // rather than relying on the "dialog:force-close" event the close button dispatches.
  document.addEventListener('click', (event) => {
    const overlay = event.target.closest('[data-newsletter-popup-overlay]');
    if (!overlay) return;

    const popup = overlay.closest('.newsletter-popup-wrapper')?.querySelector('newsletter-popup');
    popup?.hide();
  });

})();

/* accordion toggle */
$(document).ready(function () {
  $('.accordion__disclosure, .accordion__box').on('toggle', function () {
    const $this = $(this);

    if ($this.prop('open')) {
      // Close all other accordions of same type
      $(this.tagName)
      $(this).closest('body').find(this.className.split(' ')[0])

      $(this).siblings('.' + this.className.split(' ')[0])

      $(`.${this.className.split(' ')[0]}`).not(this).each(function () {
        $(this).removeAttr('open').attr('aria-expanded', 'false');
      });

      // Set this one as expanded
      $this.attr('aria-expanded', 'true');
    } else {
      $this.attr('aria-expanded', 'false');
    }
  });
});